// extracted by mini-css-extract-plugin
export var completionBody = "_ef-2";
export var completionCard = "_ef-0";
export var completionFooter = "_ef-3";
export var completionTitle = "_ef-1";